<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Banners</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <router-link
              to="/banners/new"
              type="button"
              class="btn btn-primary btn-rounded"
            >
              New Banner
            </router-link>
            <br />
            <br />
            <h4 class="card-title mb-3">Banners</h4>
            <p>The table below shows the list of active banners.</p>
            <div class="table-responsive">
              <table
                id="products_tba_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th style="width:10%">No.</th>
                    <th style="width:30%">Name</th>
                    <th style="width:40%">Banner</th>
                    <th style="width:20%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(banner, index) in banners" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ banner.name }}</td>
                    <td>
                      <img :src="bannerSource(banner)" alt="" srcset="" style="width:85%"/>
                    </td>
                    <td>
                      <router-link
                        :to="bannerDetail(banner.id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        Edit Banner
                      </router-link>

                      <button
                        class="btn btn-danger btn-rounded btn-block"
                        @click="deleteBanner(banner.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { global } from "@/global";

export default {
  name: "banners",
  components: {},

  data() {
    return {
      banners: []
    };
  },

  methods: {
    bannerDetail(id) {
      return "/banners/detail/" + id;
    },

    deleteBanner(id) {
      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (confirm) {
          let token = localStorage.getItem("token");
          if (token !== null) {
            token = JSON.parse(token);
            token = token.access_token;
            axios
              .post(
                `banners/${id}`,
                {
                  _method: "DELETE"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.success) {
                  swal({
                    icon: "success",
                    text: res.data.message
                  });

                  this.loadBanners();
                } else {
                  swal({
                    icon: "warning",
                    text: res.data.message
                  });
                }
              });
          }
        }
      });
    },
    loadBanners() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/banners", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.banners = res.data;
            setTimeout(function() {
              $("#products_tba_tbl").DataTable();
            }, 1000);
          });
      }
    },

    bannerSource(banner) {
      return `${global.base_url}/${banner.banner_link}`;
    }
  },

  mounted() {
    this.loadBanners();
  }
};
</script>
